export const keyCodes = {
    KEY_ESCAPE: 27,
    KEY_SPACE: 32,
    KEY_TAB: 9,
};

export default keyCodes;
